import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "fwdRef", "max", "min", "style", "value"];
import React, { forwardRef } from 'react';
import { buildVersionedClassNames } from '@op/opds.opux-utilities';
/**
 * _Progress bar displays the progress for a task or an operation._
 *
 * ***
 *
 * The component enables defining a progress value and minimum and maximum
 * values of the bar. The `value` can be a string that includes units.
 *
 * Additional props (including `ref`) will be forwarded to the `<div>` element.
 */
export const ProgressBar = _ref => {
  let {
      className,
      fwdRef,
      max,
      min = 0,
      style,
      value
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const valueNow = typeof value === 'string' ? parseFloat(value) || 0 : value;
  const unit = typeof value === 'string' && value.replace(/^\d+(\.\d*)?/, '').trim();
  const valueMax = max != null ? max : Math.pow(10, Math.ceil(Math.log(valueNow) / Math.LN10));
  return /*#__PURE__*/React.createElement("div", _extends({}, props, {
    "aria-valuemax": valueMax,
    "aria-valuemin": min,
    "aria-valuenow": valueNow,
    "aria-valuetext": unit ? value : undefined,
    className: buildVersionedClassNames('ds-progress-bar', className, {
      'ds-progress-bar--empty': valueNow === min
    }),
    ref: fwdRef,
    role: "progressbar",
    style: _extends({}, style, {
      paddingLeft: 100 * ((valueNow - min) / (valueMax - min)) + "%"
    })
  }));
};
const Fwd = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/React.createElement(ProgressBar, _extends({}, props, {
  fwdRef: ref
})));
Fwd.displayName = 'ProgressBar';
export default Fwd;